import React from 'react'
import { Image, CtaArrow, Link } from 'newComponents'
import OnVisibile from 'react-on-visible'
import classNames from 'classnames'

import './styles.scss'

const IconLinkTexts = ({ data }) => {
  const {
    primary: {
      title,
      content,
      cta_text: ctaText,
      cta_url: ctaUrl,
      title_and_content_on_top: contentOnTop,
      use_card_style_on_icon: useCardStyle
    },
    items
  } = data

  const TitlContent = () => {
    return (
      <>
        <div className="icon-link-texts-columns-title" dangerouslySetInnerHTML={{ __html: title.html }} />
        <div className="icon-link-texts-columns-tagline" dangerouslySetInnerHTML={{ __html: content.html }} />
        {ctaUrl.url && (
          <a href={ctaUrl.url}>
            {ctaText.text} <CtaArrow />
          </a>
        )}
      </>
    )
  }

  return (
    <div
      className={classNames('icon-link-texts', {
        'content-on-top': contentOnTop
      })}
    >
      <div className="container">
        {contentOnTop && (
          <div className="icon-link-texts-content-top">
            <TitlContent />
          </div>
        )}
        <OnVisibile className="icon-link-texts-columns">
          {!contentOnTop && (
            <div className="icon-link-texts-column icon-link-texts-columns-left">
              <TitlContent />
            </div>
          )}
          <div className="icon-link-texts-column icon-link-texts-columns-right">
            <div
              className={classNames('icon-link-texts-columns-icons-container', { 'use-card-style': useCardStyle })}
            >
              {items.map((item) => {
                const { icon, icon_url: iconUrl } = item
                return (
                  <Link to={iconUrl.url} className="icon-link-texts-columns-icon-link" key={iconUrl.url}>
                    <Image image={icon} />
                  </Link>
                )
              })}
            </div>
          </div>
        </OnVisibile>
      </div>
    </div>
  )
}

export default IconLinkTexts
